















import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/tenant/components';
import * as Common from '@/tenant/common';

@Component
export default class PnlNotificationSetting extends Vue {
  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: true }) public enabled: boolean;    
  @Prop({ default: null }) public item: Common.NotificationSettings;
  @Prop({ default: null }) public description: boolean;  
  @Prop({ default: false }) public showDaysBefore: boolean;
  @Prop({ default: false }) public showDaysAfter: boolean;
  @Prop({ default: false }) public showBaseDays: boolean;
  @Prop({ default: true }) public showSendOptions: boolean;
  @Prop({ default: false}) public isLimitedOption: boolean;

  public get sendOption(): string {return this.isLimitedOption ? 'sendOptionLimitedFlags' : 'sendOptionFlags'}
  //エディタのバインド
  public isEdit: boolean = true;
  public validator: Components.ControlValidator = null;
  public created() {
    if (this.editor != null) this.editor.addControl(this);
  }
  public destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
  }  

}
